export default "__VITE_ASSET__DiStF3pe__"